import ToolService from '@/providers/tools';
import { SectionMixin } from '@/courses/mixins/section.mixin';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class EdDeckItemComponent extends (SectionMixin) {
  
  @Prop() readonly parentId: number;
  @Prop() readonly level: number;
  @Prop() readonly name: string;

  readonly onOpen: string = 'onOpen';
  readonly onEdit: string = 'onEdit';
  public selected: boolean = false;
  public objectID: number = 0;
  public isLoading: boolean = false;
  public projectAdded: any = null;


  get classes() {
    let padding = `edg-pad-left--${this.level * 10}`;
    return { 
      'ed-deck-item--edition':  this.options.editable,
      'edg-cur--grab':  this.options.draggable,
      'edg-cur--pointer': this.options.selectable,
      'ed-deck-item--selected': this.options.selectable && this.selected, [padding]: true
    }
  }

  get loading() {
    return this.isLoading || this.section.loading 
  }

  get escapedName() {
    return ToolService.exitSpecialChars(this.section.name);
  }

  get title(){
    let msg = String(this.$i18n.t('deck.cardCounter'));
    return msg.replace('{{cards}}', String(this.section.sections.length));

  }
  

  editDeck() {
    this.$emit(this.onEdit);
  }

  openDeck() {
    this.$emit(this.onOpen);
  }

  async removeDeck() {
    this.$EdModal.createConfirmationModal(
      {
        body: this.$i18n.t('deck.confirmRemoveDeck'),
        action: async () => { this.doRemoveDeck(); }
      }
    );
  }

  async doRemoveDeck() {
    this.isLoading = true;
    await this.$Courses.Store.removeDeckA({
      deckSectionId: this.section.sectionId, 
      courseId: this.courseID , 
      classId: this.classID})
    //Refresh all content cause Sub Decks could have been deleted  
    await this.getContentForCourse({ 
      courseId: this.courseID,
      classId: this.classId
    });
    this.isLoading = false;
  }

}

